module.exports = __webpack_public_path__ + "static/media/visa_logo.1d0c5164.svg";